import {merge} from 'lodash';

//let baseURL = `https://app.mobilelocker.com/`;
let baseURL = `https://${window.location.hostname}/`;

const defaultOptions = {
  allow_conditional_comments: true, // https://www.tiny.cloud/docs/configure/content-filtering/ MLD-2624
  branding: false, // https://www.tiny.cloud/docs/configure/editor-appearance/#branding
  //content_style: 'body { font-family: Arial, sans-serif; line-height: normal;}',  // https://www.tiny.cloud/docs/configure/content-appearance/#content_style
  //convert_fonts_to_spans: true, // @deprecated https://www.tiny.cloud/docs/configure/content-filtering/#convert_fonts_to_spans
  convert_urls: false, // https://www.tiny.cloud/docs/configure/url-handling/#convert_urls
  height: 300, // https://www.tiny.cloud/docs/configure/editor-appearance/#height
  //link_assume_external_targets: true, // https://www.tiny.cloud/docs/plugins/opensource/link/#link_assume_external_targets
  menubar: false, // https://www.tiny.cloud/docs/configure/editor-appearance/#menubar
  // MLD-2694 @see https://www.tiny.cloud/docs/plugins/opensource/noneditable/
  noneditable_editable_class: 'mceEditable',
  noneditable_noneditable_class: 'mceNonEditable',
  plugins: 'mobilelockereditor anchor charmap code codesample emoticons fullscreen help hr image link lists media nonbreaking noneditable pagebreak paste preview quickbars searchreplace tabfocus table template textpattern visualblocks visualchars wordcount',
  paste_filter_drop: false, // https://www.tiny.cloud/docs/plugins/opensource/paste/#paste_filter_drop
  paste_enable_default_filters: false, // https://www.tiny.cloud/docs/plugins/opensource/paste/#paste_enable_default_filters
  relative_urls: false, // https://www.tiny.cloud/docs/configure/url-handling/#relative_urls
  remove_script_host: false, // https://www.tiny.cloud/docs/configure/url-handling/#remove_script_host
  document_base_url: baseURL, // https://www.tiny.cloud/docs/configure/url-handling/#document_base_url
  theme: 'silver',
  toolbar: 'bold underline | numlist bullist | outdent indent | link image code | removeformat | undo redo | preview',
}

/*function replaceHrefTokens(content, hrefs) {
  const hrefRegex = /(<a\s+[^>]*href=")([^"]*)("[^>]*>)/gi;
  let index = 0;
  content = content?.replace(hrefRegex, (match, p1, p2, p3) => {
    const placeholder = `__HREF_PLACEHOLDER_${index++}__`;
    hrefs.push({id: placeholder, url: p2});
    return `${p1}${placeholder}${p3}`;
  });
  return content;
}

function restoreHrefTokens(content, hrefs) {
  hrefs.forEach(href => {
    content = content.replaceAll(href.id, href.url);
  });
  return content;
}

// Function to preprocess content to remove tokens within href attributes
function preprocessContent(content, hrefs) {
  return replaceHrefTokens(content, hrefs);
}

// Function to postprocess content to restore tokens within href attributes
function postprocessContent(content, hrefs) {
  return restoreHrefTokens(content, hrefs);
}*/

export default {
  getConfig(options = {}) {
    return merge({}, defaultOptions, options);
  },
  getNonEditableRegularExpressions() {
    // MLD-6401
    // The noneditable_regexp option transforms matched text into spans which is then
    // visually styled to look like tags.
    // @see https://www.tiny.cloud/docs/plugins/noneditable/
    // @see https://github.com/tinymce/tinymce-demos/blob/master/tokens/text-based-token.html
    // @see https://chatgpt.com/c/c496b5aa-566c-4138-90ea-27a0b02f37ba
    // noneditable_regexp: /\{\{[^\}]+\}\}/g, // matches {{handlebar}},
    // noneditable_regexp: /{{[^}]+}}|{%.*?%}/g,
    // noneditable_regexp: /{{\s*[^}]+\s*}}|{%\s*[^%]+\s*%}/g,
    return [
      ///{{\s*[^}]+\s*}}/g,
      ///{%\s*[^%]+\s*%}/g
      // These seem to work
      /{{\s*[^}]+\s*}}(?![^<]*>[^<]*<\/a>)/g, // Matches {{ }} tokens not inside <a> tags
      /{%\s*[^%]+\s*%}(?![^<]*>[^<]*<\/a>)/g,  // Matches {% %} tokens not inside <a> tags
    ];
  },
  /*replaceHrefTokens,
  restoreHrefTokens,
  preprocessContent,
  postprocessContent,*/
}
